export default __webpack_public_path__ + "static/media/kitchen5-afterC-1440w.af7f3d42.avif";